<template>
    <div class="popup" :class="{active: show}">
        <div class="in">
            <div class="btn_close" @click="closePopup"></div>
            <div class="content">
                <div class="top">
                    <div class="title" v-if="!isPhone"><span>{{obj.name}}</span></div>
                    <div class="title" v-else>{{title}}</div>
                    <div class="more" v-if="!isShowSidebar" @click="isShowSidebar = true">{{$t('seeMore')}}</div>
                </div>
                <template v-if="!isPhone">
                    <template v-if="data2.length > 0">
                        <div class="video_wrap">
                            <template v-if="obj.type == 2">
                                <video class="video" ref="video" v-if="obj.video_type == 1" :src="obj.video" controls :poster="obj.image" 
                                @play="videoPlay" x5-playsinline="" playsinline="" webkit-playsinline=""></video>
                                <div class="iframe_wrap" v-if="obj.video_type == 2 && show" v-html="obj.link"></div>
                            </template>
                            <div class="image" v-if="obj.type == 1">
                                <p v-if="imgLoading">loading...</p>
                                <img v-if="!imgLoading" :src="obj.image" alt=""/>
                            </div>
                            <template v-if="data2.length > 1">
                                <div class="btn_prev" v-if="data2ActiveIndex > 0" @click="slidePrev"></div>
                                <div class="btn_next" v-if="data2ActiveIndex < data2.length - 1" @click="slideNext"></div>
                            </template>
                        </div>
                    </template>
                    <div class="sidebar" :class="{active: isShowSidebar}">
                        <div class="top1">
                            <div class="btn_close_more" @click="isShowSidebar = false"></div>
                            <img src="../assets/images/icon_video.png" alt="" 
                            class="btn" 
                            :class="{active: type == 2}" @click="changeType(2)">
                            <img src="../assets/images/icon_image.png" alt="" 
                            class="btn" 
                            :class="{active: type == 1}" @click="changeType(1)">
                        </div>
                        <swiper class="sidebar_swiper" ref="swiper" :options="Options" 
                        @click-slide="slideTap">
                            <template v-for="(item, index) in data2">
                                <swiper-slide :key="index">
                                    <div class="cover" :style="`background-image: url(${item.image});`">
                                        <!-- <img :src="item.image" alt=""> -->
                                        <img src="../assets/images/icon_video_play.png" alt="" class="icon" v-if="item.type == 2">
                                    </div>
                                    <div class="text">{{item.name}}</div>
                                </swiper-slide>
                            </template>
                            <div class="swiper-scrollbar" slot="scrollbar"></div>
                        </swiper>
                    </div>
                </template>
                <template v-else>
                    <div class="tabs">
                        <div class="item" :class="{active: type == 2}" @click="changeType(2)"><img src="../assets/images/icon_video.png" alt=""/></div>
                        <div class="item" :class="{active: type == 1}" @click="changeType(1)"><img src="../assets/images/icon_image.png" alt=""/></div>
                    </div>
                    <div class="list">
                        <template v-for="(item, index) in data2">
                            <div class="item" :key="index">
                                <div class="cover" :style="`background-image: url(${item.image});`" @click="videoTap(index)">
                                    <img :src="item.image" class="bg" v-if="type == 1" preview="1"/>
                                    <img src="../assets/images/icon_video_play.png" class="icon" v-if="type == 2"/>
                                </div>
                                <div class="text">{{item.name}}</div>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
        </div>
        <div class="in in2" v-if="isShowVideoPopup">
            <div class="btn_close" @click="isShowVideoPopup = false"></div>
            <video :src="data2[data2ActiveIndex].video" @play="videoPlay"  x5-playsinline="" playsinline="" webkit-playsinline="" controls></video>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import { Swiper, SwiperSlide, directive, scrollbar } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
    name: "imagesPopup",
    props: ['show', 'title', 'data', 'activeIndex'],
    data() {
        return {
            Options: {
                direction: 'vertical',
                slidesPerView: 'auto',
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                mousewheel: true,
                scrollbar: {
                    el: '.sidebar_swiper .swiper-scrollbar',
                },
                freeMode: true,
            },
            isShowSidebar: true,
            type: 2,
            // videoData: [],
            // imageData: [],
            data2: [],
            obj: {},
            isShowVideoPopup: false,
            data2ActiveIndex: 0,
            imgLoading: false,
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.$swiper
        },
        ...mapState(['isPhone']),
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    directives: {
        swiper: directive
    },
    mounted() {

    },
    watch: {
        show(){
            this.isShowSidebar = true;
        },
        data(value){
            this.setData();
        },
        activeIndex(value){
            this.setData();
        },
        obj(){
            let self = this;
            this.imgLoading = true;
            let img = new Image();
            img.src = this.obj.image;
            img.onload = function(){
                self.imgLoading = false;
            }
        },
    },
    methods: {
        slidePrev(){
            if(this.data2ActiveIndex > 0){
                this.data2ActiveIndex--;
            }
            this.obj = this.data2[this.data2ActiveIndex];
        },
        slideNext(){
            if(this.data2ActiveIndex < this.data2.length - 1){
                this.data2ActiveIndex++;
            }
            this.obj = this.data2[this.data2ActiveIndex];
        },
        videoPlay(){
            this.$emit('videoPlay');
        },
        videoTap(index){
            if(this.type != 2){
                return;
            }
            this.isShowVideoPopup = true;
            this.data2ActiveIndex = index;
        },
        setData(){
            this.obj = this.data[this.activeIndex];
            this.type = this.obj.type;
            this.changeType(this.type);
        },
        changeType(type){
            let self = this;
            let data = [];
            this.data.forEach((v, i)=>{
                if(v.type == type){
                    data.push(v);
                }
                if(i == self.activeIndex){
                    self.data2ActiveIndex = data.length - 1;
                }
            })
            if(data.length > 0){
                this.type = type;
                this.data2 = data;
            }else{
                this.$showToast({text: this.$t('noContentAvailable')})
            }
            this.$previewRefresh()
        },
        slideTap(index){
            this.data2ActiveIndex = index;
            this.obj = this.data2[index];
        },
        closePopup(){
            if(this.$refs.video){
                this.$refs.video.pause();
            }
            this.$emit('close');
        }
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
.popup{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: .6);
    z-index: 101;
    opacity: 0;
    visibility: hidden;
    transition: opacity .3s, visibility .3s;
    &.active{
        opacity: 1;
        visibility: visible;
    }
    .in{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #1f1f1f;
        width: 9.6rem;
        .content{
            overflow: hidden;
            width: 100%;
            position: relative;
        }
        .btn_close{
            width: .4rem;
            height: .4rem;
            border-radius: 50%;
            background: rgba($color: #000000, $alpha: 0.8);
            position: absolute;
            top: 0;
            right: -0.5rem;
            cursor: pointer;
            z-index: 1;
            &::before,
            &::after{
                content: "";
                width: .2rem;
                height: .02rem;
                background: #fff;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
        .top{
            height: .6rem;
            background: #000;
            font-size: .18rem;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 .2rem;    
            .title{
                span{
                    color: #ffb700;
                }
            }
            .more{
                display: flex;
                align-items: center;
                cursor: pointer;
                &::before{
                    content: "";
                    display: block;
                    width: .1rem;
                    height: .2rem;
                    background: url('../assets/images/icon_arrow_back.png') no-repeat 0/100%;
                    margin-right: .1rem;
                }
            }
        }
        .video_wrap{
            padding: 0 .5rem;
            position: relative;
            .btn_prev,
            .btn_next{
                width: .3rem;
                height: .3rem;
                background: url('../assets/images/icon_checked_item_arrow_prev.png') no-repeat;
                background-size: .15rem auto;
                background-position: center;
                position: absolute;
                top: 50%;
                margin-top: -.15rem;
                left: .1rem;
                cursor: pointer;
            }
            .btn_next{
                left: auto;
                right: .1rem;
                background-image: url('../assets/images/icon_checked_item_arrow_next.png');
            }
        }
        .iframe_wrap{
            width: 100%;
            /deep/iframe{
                width: 100%;
                display: block;
            }
        }
        .video{
            width: 100%;
            // height: 5.4rem;
            display: block;
        }
        .image{
            width: 100%;
            height: 5.4rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            img{
                max-width: 100%;
                width: auto;
                max-height: 100%;
                user-select: none;
            }
        }
        .sidebar{
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            width: 2.1rem;
            background: rgba($color: #323232, $alpha: .8);
            transform: translate(100%, 0);
            transition: transform .3s;
            &.active{
                transform: translate(0, 0);
            }
            .top1{
                height: .6rem;
                display: flex;
                align-items: center;
                padding: 0 .2rem;
                .btn_close_more{
                    &::before{
                        content: "";
                        display: block;
                        width: .1rem;
                        height: .2rem;
                        background: url('../assets/images/icon_arrow_back.png') no-repeat 0/100%;
                        transform: rotate(180deg);
                    }
                }
                .btn{
                    width: .32rem;
                    cursor: pointer;
                    opacity: 0.3;
                    margin-left: .3rem;
                    &.active{
                        opacity: 1;
                    }
                }
            }
            .sidebar_swiper{
                height: calc(100% - .6rem);
                padding-top: .2rem;
                .swiper-slide{
                    height: auto;
                    font-size: .14rem;
                    padding: 0 .3rem .2rem;
                    cursor: pointer;
                    .cover{
                        height: 1rem;
                        border-radius: .04rem;
                        margin-bottom: .1rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-repeat: no-repeat;
                        background-size: cover;
                        .icon{
                            width: .4rem;
                        }
                    }
                    .text{
                        text-align: center;
                        color: #fff;
                        font-size: .14rem;
                    }
                }
                .swiper-scrollbar{
                    background: rgba($color: #fff, $alpha: .2);
                    /deep/.swiper-scrollbar-drag{
                        background: #fff;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 640px) {
        .in{
            width: 100%;
            height: 100%;
            transform: none;
            top: 0;
            left: 0;
            background: rgba($color: #000000, $alpha: .8);
            .btn_close{
                top: .3rem;
                right: .3rem;
                width: .6rem;
                height: .6rem;
                background: #4c4c4c;
                &::before,
                &::after{
                    width: .3rem;
                }
            }
            .content{
                height: 100%;
                display: flex;
                flex-direction: column;
                .top{
                    height: auto;
                    background: none;
                    font-size: .3rem;
                    font-weight: bold;
                    padding: 1rem .3rem .5rem;
                    .more{
                        display: none;
                    }
                }
                .tabs{
                    display: flex;
                    padding: 0 .5rem;
                    margin-bottom: .5rem;
                    .item{
                        height: 1.1rem;
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-bottom: 1px solid rgba($color: #fff, $alpha: .2);
                        &.active{
                            border-bottom: .03rem solid #fff;
                            img{
                                opacity: 1;
                            }
                        }
                        img{
                            opacity: .3;
                            width: .64rem;
                        }
                    }
                }
                .list{
                    padding: 0 .5rem;
                    flex: 1;
                    overflow: hidden;
                    overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;
                    justify-content: space-between;
                    .item{
                        margin-bottom: .5rem;
                        .cover{
                            width: 3.1rem;
                            height: 1.94rem;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background-repeat: no-repeat;
                            background-size: cover;
                            border-radius: .05rem;
                            margin-bottom: .2rem;
                            position: relative;
                            .icon{
                                width: .6rem;
                            }
                            .bg{
                                position: absolute;
                                width: 100%;
                                height: 100%;
                                opacity: 0;
                                top: 0;
                                left: 0;
                            }
                        }
                        .text{
                            font-size: .24rem;
                            color: #fff;
                            text-align: center;
                        }
                    }
                }
            }
        }
        .in2{
            position: absolute;
            z-index: 2;
            background: #000;
            video{
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>